import _styled from 'styled-components/native'
import styled from 'styled-components'
import theme from '@app/ui/theme'

interface EvalSideBarProps {
  animLeft?: number
  collapsed?: boolean
  inAdjustment: boolean
}
const isPhone = window.innerWidth <= 767
const shadowWidth = 15
const borderRightWidth = 1
const collapsedSize = 130
const collapsedSizeString = isPhone ? '130px' : '65px'

export const EvalSideBar = styled.div<EvalSideBarProps>`
  display: flex;
  flex-direction: column;
  border-right: ${!isPhone ? '1px' : '0.5px'} solid ${theme.colors.light};
  width: ${(props) => (props.collapsed ? collapsedSizeString : '')};
  min-width: ${(props) => (props.collapsed ? collapsedSizeString : '260px')};
  background-color: white;
  transition: all 0.3s;
  animation: sidebar-in 0.3s ease;
  @keyframes sidebar-in {
    0% {
      transform: translateX(-200px);
      opacity: 0;
    }
    100% {
      transform: translateX(0px);
      opacity: 1;
    }
  }
  box-shadow: 0 0px ${!isPhone ? '12px' : '6px'} 0 ${theme.colors.dark1};
  overflow: hidden;
  height: ${({ inAdjustment }) => (inAdjustment ? '100%' : 'auto')};
`

export const EvalSideBarTopCont = styled.div`
  width: 100%;
  padding: ${!isPhone ? '16px' : '8px'};
  box-sizing: border-box;
`

export const EvalSideBarMain = styled.div<{ inAdjustment: boolean }>`
  display: flex;
  overflow-y: ${({ inAdjustment }) => (inAdjustment ? 'auto' : 'hidden')};
  flex-direction: column;
  margin-top: ${!isPhone ? '140px' : '70px'};
`

export const EvalSideBarGroupRow = styled.div`
  height: ${!isPhone ? '40px' : '20px'};
  background-color: ${theme.colors.light};

  & a {
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.8);
    display: block;
    line-height: ${!isPhone ? '40px' : '20px'};
    padding-left: ${!isPhone ? '20px' : '10px'};
    padding-right: ${!isPhone ? '10px' : '5px'};
    height: 100%;
    font-size: ${!isPhone ? '14px' : '7px'};
    font-weight: ${!isPhone ? 400 : 200};
    text-wrap: no-wrap;
    text-transform: uppercase;
  }

  &.active a {
    background-color: #666;
    color: ${theme.colors.white};
  }
`

export const EvalSideBarMenus = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
`

export const HoleButtonContainter = styled.div`
  justify-content: space-between;
  align-items: flex-start;
  display: flex;
  flex-direction: row;
`

export const CollapsedSideBarContainer = styled.div`
  width: 100%;
  height: 100%;
`

export const OptionInput = styled.input`
  margin: 0;
  padding: 0;
  width: ${!isPhone ? '45px' : '22px'};
  height: ${!isPhone ? '24px' : '12px'} !important;
  border: none;
  border: 1px solid ${theme.colors.dark1};
  border-radius: ${!isPhone ? '5px' : '2.5px'};
  outline: none;
  text-align: center;
  font-size: ${!isPhone ? '15px' : '7.5px'};
  line-height: ${!isPhone ? '24px' : '12px'};
  font-weight: bold;
  font-family: 'Proxima Nova';

  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  opacity: 1;
`

export const SideBarToggleButtonContainer = styled.div`
  min-width: ${!isPhone ? '44px' : '22px'};
`

export const CollapsedInputContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: ${!isPhone ? '5px' : '2.5px'};
  padding: ${!isPhone ? '15px' : '7.5px'};
  padding-top: ${!isPhone ? '4px' : '2px'};
  padding-bottom: ${!isPhone ? '4px' : '2px'};
`

export const CourseOptionItemContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
`

export const ParLengthLabel = styled.span`
  font-family: 'Proxima Nova';
  font-size: '22px';
  font-weight: ${!isPhone ? 600 : 400};
  margin-right: ${!isPhone ? '4px' : '2px'};
`

export const ParLengthContainer = styled.div`
  user-select: none;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`
export const ParLengthValue = styled.span`
  font-family: 'Proxima Nova';
  font-size: '22px';
  color: ${theme.colors.primary};
  font-weight: ${!isPhone ? 600 : 400};
`

export const CourseOptionItemInput = styled.input`
  -webkit-appearance: none;
  height: ${!isPhone ? '23px' : '11px'} !important;
  line-height: ${!isPhone ? '28px' : '14px'} !important;
  overflow: hidden;
  font-size: ${!isPhone ? '15px' : '8px'};
  padding: 0px !important;
  &:disabled {
    opacity: 1;
  }
`

export const CollapsedContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  line-height: ${!isPhone ? '40px' : '20px'};
`
export const LiveCRInfoContainer = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: ${({ theme }) => theme.baseline}px;
`

export const LiveCRInfoDivider = styled.hr`
  width: 100%;
  height: ${!isPhone ? '1px' : '0.5px'};
  border: none;
  background-color: ${({ theme }) => theme.colors.light};
`

export const LiveCRInfoTextContainer = styled.div`
  width: 90%;
  margin: ${!isPhone ? '4px' : '2px'} 0;
`

export const LiveCRInfoText = styled.div``

export const LiveCRInfoValue = styled.div`
  display: inline;
  font-weight: ${!isPhone ? 600 : 300};
`

export const LiveCRInfoButtonContainer = styled.div`
  margin: ${!isPhone ? '4px' : '2px'} 0;
  width: 80%;
`

interface CourseOptionViewProps {
  justifyInnerContent?: string
}

export const CourseOptionView = styled.div<CourseOptionViewProps>`
  user-select: none;
  display: flex;
  flex: 1;
  justify-content: flex-start;
  width: 100%;

  & > div {
    display: flex;
    flex: 1;
    justify-content: ${(props) => props.justifyInnerContent ?? 'space-between'};
    align-items: center;
  }

  & > div > div {
  }

  & span {
    font-size: ${!isPhone ? '15px' : '7.5px'};
    font-weight: 460;
    color: rgba(0, 0, 0, 0.8);
    float: left;
    line-height: ${!isPhone ? '24px' : '12px'};
  }

  & input {
    width: ${!isPhone ? '45px' : '22px'};
    height: ${!isPhone ? '36px' : '18px'};
    border: none;
    border: ${!isPhone ? '1px' : '0.5px'} solid ${theme.colors.dark1};
    border-radius: ${!isPhone ? '5px' : '2.5px'};
    outline: none;
    text-align: center;
    font-size: ${!isPhone ? '16px' : '8px'};
    line-height: ${!isPhone ? '36px' : '18px'};
    font-weight: bold;
    font-family: 'Proxima Nova';
    align-self: flex-end;
    -webkit-appearance: none;
    appearance: none;
    opacity: 1;
  }
  & select {
    width: ${!isPhone ? '60px' : '30px'};
    height: ${!isPhone ? '36px' : '18px'};
    border: none;
    background-color: ${theme.colors.light2};
    border-radius: ${!isPhone ? '5px' : '2.5px'};
    outline: none;
    text-align: center;
    font-size: ${!isPhone ? '16px' : '8px'};
    line-height: ${!isPhone ? '36px' : '18px'};
    font-weight: bold;
    font-family: 'Proxima Nova';
    align-self: flex-end;
    text-align-last: center;
    padding-left: ${!isPhone ? '9px' : '4.5px'};
    border-right: ${!isPhone ? '10px' : '5px'} solid ${theme.colors.light2};
  }
`
export const EvalSideBarTop = styled.div`
  justify-content: flex-end;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  border-top: ${!isPhone ? '3px' : '1.5px'} solid transparent;
  border-right: ${!isPhone ? '3px' : '1.5px'} solid transparent;
  border-left: ${!isPhone ? '3px' : '1.5px'} solid transparent;
  background-color: ${theme.colors.white};
  overflow-wrap: never;
  & h2 {
    letter-spacing: 0.6;
    font-size: ${!isPhone ? '20px' : '10px'};
    color: rgba(0, 0, 0, 0.8);
    display: block;
    width: 100%;
    font-weight: ${!isPhone ? 460 : 230};
    line-height: ${!isPhone ? '40px' : '20px'};
  }
  & span {
    font-size: ${!isPhone ? '15px' : '7.5px'};
  }
  position: sticky;
  top: 0;
  z-index: 10;
`
